var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$tc("PathInspector"),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y
    },
    on: { close: _vm.closePathInspector },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [
            _c("PathInspectorSVG", { staticClass: "floating-container-svg" })
          ]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "floating-tool-content" },
              [
                _c(
                  "div",
                  { staticStyle: { "text-align": "left", margin: "0" } },
                  [
                    _vm.selectedObjects.length !== 0
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "clear-button ma-0",
                            attrs: { small: "", text: "" },
                            on: { click: _vm.clearSelectedObjects }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "padding-right": "5px" } },
                              [_vm._v("clear_all")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("ClearAll")) +
                                "\n        "
                            )
                          ],
                          1
                        )
                      : _c("div", { staticStyle: { height: "10%" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "floating-objects-wrapper" },
                  _vm._l(_vm.selectedObjects, function(object, index) {
                    return _c(
                      "div",
                      {
                        key: object.uuid,
                        ref: "listItem",
                        refInFor: true,
                        staticClass: "floating-object-selected"
                      },
                      [
                        object.type.toLowerCase() === "central office"
                          ? _c("COSVG", { staticClass: "floating-img" })
                          : object.type.toLowerCase() === "primary node"
                          ? _c("PNSVG", { staticClass: "floating-img" })
                          : object.type.toLowerCase() === "toby box"
                          ? _c("TobyBoxSVG", { staticClass: "floating-img" })
                          : _c("img", {
                              staticClass: "floating-img",
                              attrs: {
                                src: require("@/assets/objectIcons/" +
                                  object.type.toLowerCase() +
                                  ".png")
                              }
                            }),
                        _vm._v(" "),
                        object.uuid !== _vm.selectedObjects[0].uuid
                          ? _c("div", {
                              staticClass: "floating-between-objects",
                              staticStyle: { "border-color": "#4fa2b7" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "padding-right": "5px"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.objectIdentification(object)) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "floating-hover-options",
                            on: {
                              click: function($event) {
                                return _vm.openObjectMenu($event, object, index)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("more_vert")])],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("HighlightedBox", {
                  class: { "mt-0": _vm.selectedObjects.length === 0 },
                  attrs: {
                    "bad-object": _vm.badObject,
                    "is-visible": true,
                    message: _vm.getMessageForHighlightedBox(),
                    state: _vm.state,
                    loading: _vm.loading
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.objectMenu.open
              ? _c("window-object-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeObjectMenu,
                      expression: "closeObjectMenu"
                    }
                  ],
                  style: {
                    top: _vm.getTopObjectMenu,
                    left: _vm.getLeftObjectMenu
                  },
                  attrs: {
                    event: _vm.objectMenu.event,
                    object: _vm.objectMenu.object,
                    actionFrom: _vm.selectedToolObjectLayer
                  },
                  on: {
                    updateGeoServer: _vm.updateGeoServer,
                    closeMenu: _vm.closeObjectMenu,
                    openForm: _vm.openFormFromObjectMenu,
                    openDetailForm: function($event) {
                      return _vm.openFormFromObjectMenu("detail")
                    },
                    removeFromCable: _vm.removeObjectFrom
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1af9ed20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af9ed20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/PathInspectorToolbar.vue
// module id = null
// module chunks = 